import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import { ActionOpenRegisterLayout } from 'app/containers/EventManagement/RegisterActivity/RegisterForMemberContainer/layouts'
import { useGetActionNotJoinByMember } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useMemo } from 'react'
import { ActionJoin, ListNewLayout } from './layouts'
import { EventInSevenDay } from '../DashboardAdmin/layouts/EventInSevenDay'
export const DashboardMemberLayout = () => {
  const user = useAppSelector(state => state?.user)?.profile

  const { data: response, isLoading } = useGetActionNotJoinByMember()

  const dataOpen = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  return (
    <BaseSpace>
      <ListNewLayout />

      <EventInSevenDay />

      <ActionJoin />

      {user?.member?.id ? (
        <BaseSpace>
          <SectionBase title="Danh sách hoạt động/sự kiện đang mở đăng ký">
            <ActionOpenRegisterLayout
              data={dataOpen ?? []}
              isLoading={isLoading}
            />
          </SectionBase>
        </BaseSpace>
      ) : null}
    </BaseSpace>
  )
}
